// extracted by mini-css-extract-plugin
module.exports = {"Features":"Features_Features__xaz79","list":"Features_list__HJcPb","item":"Features_item__2VdPf","title":"Features_title__aNFvQ","icon":"Features_icon__bwNom"};